import mutations from "./mutations";
import * as actions from "./actions";
import * as getters from "./getters";

// state
let state = {
    shop: null,
    blog: null,
    productsLog: null,
    cart: {}
}

export default {mutations, actions, state, getters}


// WEBPACK FOOTER //
// ./src/store/modules/squarespace/index.js